import {
  INITIALIZE,
  SHOW_CATEGORY_FLYOUT_ITEM,
  SHOW_CATEGORIES_FLYOUT,
  SUBNAV_INIT,
} from 'app/common/constants/action-types';
import { transformCategoriesFlyouts } from 'app/desktop/helpers/categories';

export const INITIAL_STATE = {
  activeTab: null,
  primary: [],
  cards: {},
  catFlyouts: [],
  isCategoriesFlyoutDisplayed: false,
  activeCategory: 'local',
};

const initNavbar = (state, action) => {
  const { navbar } = action.payload || {};
  const { primary, couponsSubnavLinks } = navbar || {};
  if (!Array.isArray(primary)) {
    return state;
  }

  return {
    ...state,
    primary,
    couponsSubnavLinks,
  };
};

function categoriesReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case INITIALIZE:
      return initNavbar(state, action);
    case SUBNAV_INIT: {
      const { categories, cards } = action || {};
      if (!categories) {
        return state;
      }
      const { couponsSubnavLinks } = state;
      const { categoriesFlyout, occasionLinks } = categories;
      return {
        ...state,
        catFlyouts: transformCategoriesFlyouts(
          categoriesFlyout,
          couponsSubnavLinks
        ),
        cards,
        occasionLinks,
      };
    }
    case SHOW_CATEGORIES_FLYOUT: {
      return {
        ...state,
        isCategoriesFlyoutDisplayed: !state.isCategoriesFlyoutDisplayed,
        activeCategory: 'local',
      };
    }
    case SHOW_CATEGORY_FLYOUT_ITEM:
      const { activeCategory } = action;
      return {
        ...state,
        activeCategory,
      };
    default:
      return state;
  }
}

export default categoriesReducer;
